import utils from './utils';
import query from 'common/js/query';
import Queue from 'common/js/queue';
import logger from 'common/js/logger';

export default class UDBUtils {
    constructor() {
	    if(UDBUtils.instance) {
		    return UDBUtils.instance;
	    }

	    this.jssdkUrl = process.env.REACT_APP_HOST_UDB;
	    this.searchStr = query.value;
	    this.inited = false;
        this.init();
	    this.loginCallback = new Queue();
	    this.regCallback = new Queue();

	    UDBUtils.instance = this;
    }

    /**
     * 初始化UDB登录信息
     */
    init(args) {
	    var self = this;

	    if(window.HyUDBWebSDK){
		    self.initUDB(args);
	    }else{
		    utils.load(this.jssdkUrl).then(function() {
			    self.initUDB(args);
			    logger.log('udb jssdk load success');
		    }).catch(function(res){
			    logger.log('udb jssdk load error');
		    });
	    }

    }

	initUDB(args) {
		var self = this;
		var oOptions = Object.assign(args || {}, {
				appid: utils.isWx ? 5003 : 5002,
				byPass: 2
			}),
			oDomainFunc = {
				login: 'udblgn',
				register: 'udbreg',
				thrid: 'udb3lgn'
			},
			protocol = 'http';

		// 测试环境配置
		if(utils.isDebug) {
			oDomainFunc = {
				login: 'udblgn-test',
				register: 'udbreg-test',
				thrid: 'udb3lgn-test'
			};
			protocol = 'http';

		}
		// 初始化UDB
		window.HyUDBWebSDK && window.HyUDBWebSDK.init({
			appid: oOptions.appid,
			byPass: oOptions.byPass,
			protocol: protocol,
			domainFunc: oDomainFunc,
			success: function() {
				self.inited = true;
				args && args.callback && args.callback();
				logger.log("UDB初始化成功");
			},
			error: function (response) {
				logger.log(response.uri + ":" + response.version + ":" + response.message + ":" + response.description);
			}
		});
	}

	buildTrack(options) {
		let channel = this.searchStr['promoter'] || this.searchStr['channel'] || "";

		if (options.hasOwnProperty('data')){
			options['data']['track'] = {
				'biz': 'hyrev',
				'source': 'wap',
				'channel': channel
			};
		}else{
			options['data'] = {
				'track': {
					'biz': 'hyrev',
					'source': 'wap',
					'channel': channel
				}
			};
		}

		options['busiurl'] = options['busiurl'];

		return options;
	}

	addLoginCallback(fn) {
		this.loginCallback.add(fn);
	}

	addRegCallback(fn) {
		this.regCallback.add(fn);
	}

	claer(type) {
		if(type === 'reg') {
			this.regCallback.clear();
		}else if(type === 'login'){
			this.loginCallback.clear();
		}else{
			this.regCallback.clear();
			this.loginCallback.clear();
		}
	}

	accountRequest(params) {
		let self = this;
		window.HyUDBWebSDK.Login.V2.account({
			data: {
				userName: "086" + params.userName,
				password: window.HyUDBWebSDK.Security.SHA1.hexEncode(params.password),
				remember: 1
			},

			success: function(res) {
				logger.log('登录成功',res);
				self.loginSuccessSetCookie({
					type: 0,
					response: res,
					account: "086" + params.userName,
					callback: function() {
						params.success && params.success(res);
						self.loginCallback.run(res);
					}
				});
			},
			strategy: function(res) {
				logger.log('strategy',res);
			},
			error: function(res) {
				logger.log('登录失败',res);
				params.fail && params.fail(res);
			}
		});
	}

	/**
	 * 账号登录
	 */
	account(params) {
		let self = this;

		if(this.inited){
			this.accountRequest(params);
		}else{
			this.init({callback: function(){
				self.accountRequest(params);
			}});
		}
	}

	thirdRequest(params) {
		let self = this;
		logger.log(this.buildTrack({
			type: params.type,
			win: 3,
			busiurl: window.location.href,
			success: function(res) {
				logger.log('登录成功',res);

				self.loginSuccessSetCookie({
					type:1,
					response: res,
					callback: function() {
						params.success && params.success(res);
						self.loginCallback.run(res);
					}
				});
			},
			error: function(res) {
				logger.log('登录失败',res);
				params.fail && params.fail(res);
			}
		}));
		window.HyUDBWebSDK.Login.V2.third(
			this.buildTrack({
				type: params.type,
				win: 3,
				busiurl: window.location.href,
				success: function(res) {
					logger.log('登录成功',res);

					self.loginSuccessSetCookie({
						type:1,
						response: res,
						callback: function() {
							params.success && params.success(res);
							self.loginCallback.run(res);
						}
					});
				},
				error: function(res) {
					logger.log('登录失败',res);
					params.fail && params.fail(res);
				}
			})
		);
	}

	/**
	 * 第三方登录
	 */
	third(params) {
		let self = this;

		if(this.inited){
			this.thirdRequest(params);
		}else{
			this.init({callback: function(){
				self.thirdRequest(params)
			}});
		}
	}

    /**
     * 微信公众号登录唤起
     * @param args {Object} {channel: 渠道id, busiurl: 回调url}
     */
    wechat(args) {
        let options = {
            style:2,
            type: 'wx',
            terminal: 'oa',
            data: {
                track: {
                    biz: 'hyrev',
                    source: 'wxoa',
                    channel: args.channel || ''
                }
            },
            busiurl: args.busiurl
        };

        if(this.inited){
            window.HyUDBWebSDK.Login.V2.third(options);
        }else{
            this.init({callback: function(){
                window.HyUDBWebSDK.Login.V2.third(options);
            }});
        }

    }

	/**
	 * type, response, account, callback
	 * @param params
	 */
	loginSuccessSetCookie(params) {
		var busiUrl = window.location.href,
			HyUDBWebSDK = window.HyUDBWebSDK;
		if(params.type==0)
		{
			try{
				if(params.account!=undefined && params.account!="") {
					HyUDBWebSDK.Cookie.set("udb_accdata",params.account,HyUDBWebSDK.JSSDK.Global.domain,30);
				}
			}catch(except){}
			HyUDBWebSDK.html({tag:'iframe',urlList:[{id:'udb_exchangesuccess',url:"https://lgn.huya.com/lgn/jump/authentication.do?action=authenticate&appid=5060&busiId="+"5913" +"&direct=1&cks=true&busiUrl="+encodeURIComponent(busiUrl+"&loginTime="+params.response.data.loginTime+"&sign="+params.response.data.sign)+"&ticket="+encodeURIComponent(params.response.data.ticket5060)+"&yyuid="+params.response.data.uid}],callback: function(){params.callback && params.callback()} });
			//window.location.href = "https://lgn.huya.com/lgn/jump/authentication.do?action=authenticate&appid=5060&busiId="+"5913" +"&direct=1&cks=true&busiUrl="+encodeURIComponent(busiUrl+"&loginTime="+response.data.loginTime+"&sign="+response.data.sign)+"&ticket="+encodeURIComponent(response.data.ticket5060)+"&yyuid="+response.data.uid;
		}else if(params.type==1)
			HyUDBWebSDK.html({tag:'iframe',urlList:[{id:'udb_exchangesuccess',url:busiUrl+"&type="+params.response.data.type+"&loginTime="+params.response.data.loginTime+"&sign="+params.response.data.sign}],callback: function(){params.callback && params.callback()} });
		else if(params.type==2){
			params.response.data["callback"]=busiUrl;
			params.response.data["remember"]=1;
			HyUDBWebSDK.html({tag:'iframe',urlList:[{id:'udb_exchangesuccess',url:HyUDBWebSDK.Login.V2.quick(params.response)}],callback: function(){params.callback && params.callback()}});
		}
	}


	/**
     * 退出登录
     * @param fn {Function} 退出回调方法
     */
    logout(fn) {
        window.HyUDBWebSDK.Login.logout({
            success: function() {
                fn && fn();
            }
        });
    }

	/**
	 * 发送验证码
	 */
	code(param) {
		window.HyUDBWebSDK.Code.V2.send({
			style:1,
			data:{
				phone: "086" + param.phone
			},
			success:function(res){
				param.success && param.success(res);
			},
			error:function(res){
				param.fail && param.fail(res);
			}
		});
	}

	/**
	 * 验证手机号码
	 */
	verifyPhone(param) {
		window.HyUDBWebSDK.Item.Verify.Server.V2.phone({
			data:{
				phone: "086" + param.phone
			},
			success:function(res){
				param.success && param.success(res);
			},
			error:function(res){
				param.fail && param.fail(res);
			}
		});
	}

	/**
	 * 注册
	 */
	register(params) {

		let self = this;

		if(this.inited){
			this.registerRequest(params);
		}else{
			this.init({callback: function(){
				self.registerRequest(params)
			}});
		}

	}

	registerRequest(params) {
		window.HyUDBWebSDK.Register.V2.phone(
			this.buildTrack({
				data:{
					phone: "086" + params.phone,
					password:params.password,
					smsCode:params.code
				},
				success: function(res) {
					logger.log('注册成功',res);
					params.success && params.success(res);
				},
				error: function(res) {
					logger.log('注册失败',res);
					params.fail && params.fail(res);
				}
			})
		);
	}
}


// WEBPACK FOOTER //
// ./src/common/js/udb.common.js